import { useAnalysisFormStore } from '../../../model/analysisFormStore';
import { ExtractFromDocumentTab } from '../shared';

export const CompetitorExtractFromDocumentTab = () => {
  const files = useAnalysisFormStore((s) => s.competitorUploadedFiles);
  const onAddFiles = useAnalysisFormStore((s) => s.addCompetitorUploadedFiles);
  const onRemoveFile = useAnalysisFormStore((s) => s.removeCompetitorUploadedFile);

  return (
    <ExtractFromDocumentTab files={files} onAddFiles={onAddFiles} onRemoveFile={onRemoveFile} />
  );
};
